module.exports = __webpack_public_path__ + "img/micon-2.fceca62d.svg";